module.exports = __webpack_public_path__ + "assets/img/gal_08.a00b2a53.jpg";